export var PartitionSegmentType;
(function (PartitionSegmentType) {
    PartitionSegmentType["PARTITION_SEGMENT_TYPE_PRIMARY"] = "PRIMARY";
    PartitionSegmentType["PARTITION_SEGMENT_TYPE_SECONDARY"] = "SECONDARY";
    PartitionSegmentType["PARTITION_SEGMENT_TYPE_DATE"] = "DATE";
})(PartitionSegmentType || (PartitionSegmentType = {}));
